import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const BlankSlate = () => {
  return (
    <Box
      flexDirection="row"
      background="grey000White"
      justifyContent="center"
      width="full"
      padding="s32"
    >
      <Text.Normal>{i18n.t('settings.work_schedule.period_section.no_period')}</Text.Normal>
    </Box>
  )
}

export default BlankSlate
